"use strict";
import React from "react";

const initComponent = (flex = window.flex) => {

    class VehicleSummary extends React.PureComponent {
        static defaultProps = {
            vehicle: false
        };

        handleShowDetail = (vehicle) => {
            flex.trigger("workbench:set-current-vehicle", vehicle);
        };

        render() {
            const self = this;
            const vehicle = this.props.vehicle || {};
            const build = vehicle.build || {};
            const instance = vehicle.instance || {};
            flex.log("Vehicle summary: ", vehicle);
            const primaryImage = instance && instance.primaryImage ? instance.primaryImage.replace("_Thumbnail", "_Beautyshot") : "/content/img/listing-nopic.jpg";
            return (
                <div className="listing vdp-listing">
                    <div className="xs-visible">
                        <span className="vehicle-name">{build.title}</span>
                        <span className="vehicle-summary">68,542 miles, blue</span>
                        <span className="time-left">57m, 37s left</span>
                    </div>

                    <div className="xs-visible" data-set="mandatory-alert"></div>

                    <div className="row">
                        <div className="vehicle-thumb atd-image-display col-sm-3">
                            <div className="image-container">
                                <a href="#slider-modal">
                                    <img className="slider-main-image" src={primaryImage} data-target="atd-image-display" alt="" />
                                </a>

                                <span className="click-text click-only">Click for larger view</span>
                                <a href="#" className="prev-image print-hidden"><span className="glyphicon glyphicon-triangle-left"></span></a>
                                <a href="#" className="next-image print-hidden"><span className="glyphicon glyphicon-triangle-right"></span></a>
                            </div>

                            <div className="slider mini-slider atd-slider xs-hidden  print-hidden">
                                <a href="#" className="btn slide-prev" title="Previous Slide">&lt;</a>
                                <a href="#" className="btn slide-next" title="Next Slide">&gt;</a>

                                <ul className="slide-list">
                                    <li className="slide row">
                                        <a href="#" data-image-src="/content/img/vdp-thumb.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-2.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-2.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-3.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-3.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-4.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-4.jpg" alt="Resource" />
                                        </a>
                                    </li>

                                    <li className="slide out-right row">
                                        <a href="#" data-image-src="/content/img/vdp-thumb.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-2.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-2.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-3.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-3.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-4.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-4.jpg" alt="Resource" />
                                        </a>
                                    </li>

                                    <li className="slide out-right row">
                                        <a href="#" data-image-src="/content/img/vdp-thumb.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-2.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-2.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-3.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-3.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-4.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-4.jpg" alt="Resource" />
                                        </a>
                                    </li>

                                    <li className="slide out-right row">
                                        <a href="#" data-image-src="/content/img/vdp-thumb.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-2.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-2.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-3.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-3.jpg" alt="Resource" />
                                        </a>

                                        <a href="#" data-image-src="/content/img/vdp-thumb-4.jpg" data-image-alt="2013 BMW 5 Series lx" className="resource col-sm-6 col-md-3">
                                            <img className="slide-thumb" src="/content/img/vdp-thumb-4.jpg" alt="Resource" />
                                        </a>
                                    </li>
                                </ul>

                                <a onClick={self.handleShowDetail.bind(self, vehicle)} className="view-details-pane" data-target="#info-modal" data-toggle="modal">
                                    View Details Pane
                                    <span className="icon icon-modal inline-icon"></span>
                                </a>
                            </div>
                        </div>

                        <div className="listing-content col-sm-6">
                            <span className="vehicle-name xs-hidden">{build.title}</span>
                            <span className="vehicle-desc"><strong className="desc-label">VIN:</strong> <span className="desc-value">{build.vin}</span></span>

                            <div className="vehicle-stats row">
                                <dl className="col-sm-12 col-md-6">
                                    <dt>Mileage:</dt>
                                    <dd> 66,542</dd>

                                    <dt>Engine:</dt>
                                    <dd> {build.engineDescription}</dd>

                                    <dt>Transmission:</dt>
                                    <dd> {build.transmissionDescription}</dd>

                                    <dt>As Is?:</dt>
                                    <dd> Yes</dd>

                                    <dt>Seller:</dt>
                                    <dd> Car Auctions, Inc.</dd>
                                </dl>

                                <dl className="col-sm-12 col-md-6">
                                    <dt>Grade:</dt>
                                    <dd> B</dd>

                                    <dt>Location:</dt>
                                    <dd> Atlanta, GA</dd>

                                    <dt>Facilitating Location:</dt>
                                    <dd> Car Auctions, Inc.</dd>

                                    <dt>Proximity:</dt>
                                    <dd> 50 miles</dd>
                                </dl>
                            </div>
                        </div>

                        <div className="listing-meta col-sm-3">
                            <div className="price-block">
                                <span className="vehicle-cost">$57,875</span>
                                <span className="buy-it-now-price"><strong>MMR:</strong> $43,228</span>
                            </div>

                            <div className="tag-block">
                                <span className="listing-tag winning-tag">winning</span>
                            </div>

                            <div className="bids-block">
                                <span className="bid-count"><strong>Current Bid:</strong> <strong>9</strong> bids (Reserve Met)</span>
                                <span className="time-left">57m, 37s left</span>
                            </div>

                            <div className="vdp-action bid-action">
                                <span className="buy-it-now-price"><strong>Your Max Bid:</strong> $58,995</span>
                                <a href="#" className="btn" data-toggle="popover" data-placement="bottom">Raise Bid</a>
                            </div>

                            <div className="vdp-action buy-now-action">
                                <span className="buy-it-now-price"><strong>Buy It Now Price:</strong> $75,000</span>
                                <a href="#" className="btn">Buy It Now</a>
                            </div>

                            <a href="#" className="watchlist-link">Add To My Watch List</a>
                        </div>
                    </div>
                </div>
            );
        }
    }

    return VehicleSummary;
};

module.exports = initComponent;
